import { Schema, model } from "mongoose";

/**
 * A conversation between people on one domain.
 *
 * `type` is here from the start so groups drop in later without a migration —
 * a direct chat is simply a conversation with two participants.
 *
 * Participants are stored as MailboxUser ids, never as email addresses. If a
 * mailbox is ever renamed, the conversation follows the person.
 */
const conversationSchema = new Schema(
  {
    type: { type: String, enum: ["direct", "group"], default: "direct" },

    /** MailboxUser ids, sorted, so a direct pair has one canonical form. */
    participants: [{ type: Schema.Types.ObjectId, required: true }],
    /** Sorted ids joined by ":" — makes "do these two already have a chat?" a single lookup. */
    pairKey: { type: String, default: null },

    // THE WALL: a conversation belongs to one domain and one client.
    domain: { type: String, required: true, lowercase: true },
    clientId: { type: Schema.Types.ObjectId, default: null },

    title: { type: String, default: "" }, // groups only

    lastMessageAt: { type: Date, default: Date.now },
    lastMessagePreview: { type: String, default: "" },
    lastMessageBy: { type: Schema.Types.ObjectId, default: null },
  },
  { timestamps: true }
);

conversationSchema.index({ participants: 1, lastMessageAt: -1 });
conversationSchema.index({ pairKey: 1 }, { unique: true, sparse: true });
conversationSchema.index({ domain: 1 });

export const Conversation = model("Conversation", conversationSchema);

/** Same two people always produce the same key, whichever order they arrive in. */
export function pairKeyFor(a: string, b: string): string {
  return [String(a), String(b)].sort().join(":");
}
